import React from 'react'
import { Link } from 'react-router-dom'

class BackButtonComponent extends React.Component {
  render () {
    return (
      <div style={styles.buttonContent}>
        <Link style={styles.link} to={this.props.link}>
          <button
            style={styles.button}
            onClick={() => this.props.onClick()}>
            <img
              style={styles.icon}
              src={this.props.img}
              alt='true'
            />
            <span style={styles.label}>{this.props.label}</span>
          </button>
        </Link>
      </div>
    )
  }
}

const styles = {
  link: {
    textDecoration: 'none'
  },
  buttonContent: {
    marginTop: '10px',
    marginLeft: '14px',
    float: 'left',
    height: '34px'
  },
  button: {
    cursor: 'pointer',
    marginTop: '4px',
    width: '70px',
    height: '26px',
    border: 'none',
    backgroundColor: '#16191C',
    outline: 'none'
  },
  label: {
    textAlign: 'left',
    color: '#7ED321',
    fontSize: '14px',
    fontWeight: 600
  },
  icon: {
    float: 'left',
    marginLeft: '-12px',
    marginTop: '2px',
    width: '15px',
    height: '15px'
  }
}

export default BackButtonComponent
